/*eslint  @typescript-eslint/no-use-before-define: 0*/
import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import _ from "lodash";
import { FILTER_NAMES } from "@/static/filterNames";
import { getAdvanceDocumentsTable } from "@/requests/document";
import { DataOptions } from "vuetify";
import { DefaultDataOptions } from "@/models/components/dataTables/DataTableOptions";
import { AdvanceDocument } from "@/models/api/documents/AdvanceDocumentsList";
import { filterCapitalize } from "@/filters/capitalize";
import i18n from "@/plugins/i18n";
import { getIsAdvanceDocumentLargerAmountThanOrder } from "@/requests/order/orderAddEdit";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";

export interface AdvanceDocumentStateInterface {
  isDialog: boolean;
  isLoading: boolean;
  dataTableOptions: DataOptions;
  filters: null | Array<CriterionItemRequest>;
  advanceDocuments: Array<AdvanceDocument>;
  countAdvanceDocument: number;
}

export const AdvanceDocumentState: AdvanceDocumentStateInterface = {
  isDialog: false,
  isLoading: false,
  dataTableOptions: new DefaultDataOptions(),
  advanceDocuments: [],
  filters: null,
  countAdvanceDocument: -1,
};

const AdvanceDocumentModule = defineModule({
  state: AdvanceDocumentState as AdvanceDocumentStateInterface,
  namespaced: true as const,
  mutations: {
    setIsDialog(state, param: boolean) {
      state.isDialog = param;
    },
    setIsLoading(state, param: boolean) {
      state.isLoading = param;
    },
    setAdvanceDocumentItems(state, param) {
      state.advanceDocuments = param;
    },
    setAdvanceDocumentCount(state, param) {
      state.countAdvanceDocument = param;
    },
    setFilters(state, param) {
      state.filters = param;
    },
    setDataTableOptions(state, param: DataOptions) {
      state.dataTableOptions = JSON.parse(JSON.stringify(param));
    },
  },
  actions: {
    async importDocuments(context, param: Array<AdvanceDocument>) {
      const { commit, rootDispatch, rootState } = _moduleActionContext(context);
      let recalculateAdvanceDocuments = false;
      const documentIds: string[] = [];

      param.forEach((x) => {
        documentIds.push(x.documentId);
        x.documentCorrection.forEach((y) => {
          documentIds.push(y.documentId);
        });
      });

      const isAdvanceDocumentLargerAmountThanOrder = await getIsAdvanceDocumentLargerAmountThanOrder(
        rootState.orderAddEdit.operationId as string,
        documentIds
      );

      if (isAdvanceDocumentLargerAmountThanOrder) {
        recalculateAdvanceDocuments = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning").toString()),
          content: filterCapitalize(i18n.t("doYouWantToModifyAdvanceAmountToOrderAmount?").toString()),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no").toString()),
              color: "error",
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes").toString()),
              color: "success",
              value: true,
            },
          ],
        })) as boolean;
      }

      await rootDispatch.orderAddEdit.commands.importAdvanceDocuments({
        documentIds: documentIds,
        recalculateAdvanceDocuments: recalculateAdvanceDocuments,
      });
      commit.setIsDialog(false);
    },
    async openDialog(context) {
      const { commit, dispatch } = _moduleActionContext(context);
      commit.setIsDialog(true);
      dispatch.getDocumentsTable();
    },
    async getDocumentsTable(context) {
      const { commit, state } = _moduleActionContext(context);
      commit.setIsLoading(true);
      commit.setAdvanceDocumentItems([]);
      const response = await getAdvanceDocumentsTable({
        count: state.dataTableOptions.itemsPerPage,
        page: state.dataTableOptions.page - 1,
        criterions: _.cloneDeep(state.filters),
        filterName: FILTER_NAMES.AdvanceDocumentListStandardFilter,
      });
      commit.setAdvanceDocumentItems(response.items);
      commit.setAdvanceDocumentCount(response.totalCount);
    },
  },
});

export default AdvanceDocumentModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, AdvanceDocumentModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdvanceDocumentModule);
